export class UploadFile {
  public File: File;
  public Descricao: string;
  public progress: number = 0;
}

export class UploadStatusNome {
  status = false;
  nomeArquivo = '';
}
